export const MT_ENTITY_COLUMNS = [
  {
    id: 'entityName',
    label: 'Entity name',
  },
  {
    id: 'uniqueIdentificationNumber',
    label: 'Unique identification number',
    isFormatted: false,
  },
  {
    id: 'countryName',
    label: 'Country',
  },
  {
    id: 'createdBy',
    label: 'Created by',
  },
  {
    id: 'createdDate',
    label: 'Created date',
  },
  {
    // Field id must match the backend search allow-list / response field
    // (`lastModifiedBy`), otherwise the advanced-search "Updated by" filter is
    // silently ignored by the server. Aligns with TIN and User setup pages.
    id: 'lastModifiedBy',
    label: 'Updated by',
  },
  {
    // Same rationale as above — backend date column is `lastModifiedDate`.
    id: 'lastModifiedDate',
    label: 'Updated date',
  },
]
